import { useState } from 'react'
import { capitalize } from '@/shared/tools/stringFunctions'
import useAdditionalSalesContainer from '../AdditionalSales/useAdditionalSalesContainer'
import { groupProducts } from './groupProducts'
import type { SalesPole } from './poles'
import { productTitle } from './productDisplay'
import useSalesPole from './useSalesPole'

const keyAsTitle = (key: string) => key

const useAdditionalSalesV2Container = () => {
  const {
    t,
    hideComponent,
    activeTab,
    setActiveTab,
    groupConfig,
    zohoSaleType = 'sales',
    searchValue,
    setSearchValue,
  } = useAdditionalSalesContainer()
  const [formulaList, setFormulaList] = useState<HTMLElement | null>(null)
  const [notice, setNotice] = useState<HTMLElement | null>(null)
  const available = Object.values(groupProducts(groupConfig, '', keyAsTitle)).flat()
  const { poles, pole, needsPole, selectPole } = useSalesPole(available)
  const products = groupProducts(groupConfig, searchValue, key => productTitle(t, key), pole)

  const countOf = (candidate: SalesPole) => {
    const { main, secondary, leads } = groupProducts(groupConfig, '', keyAsTitle, candidate)
    return main.length + secondary.length + leads.length
  }

  const changePole = (id: string) => {
    selectPole(id)
    const next = poles.find(candidate => candidate.id === id)
    if (next && ![...next.main, ...next.secondary, ...next.leads].includes(activeTab)) {
      setActiveTab(groupProducts(groupConfig, '', keyAsTitle, next).main[0] ?? activeTab)
    }
  }

  return {
    t,
    hideComponent,
    activeTab,
    setActiveTab,
    searchValue,
    setSearchValue,
    products,
    poles,
    pole,
    countOf,
    changePole,
    setFormulaList,
    setNotice,
    showSale: Boolean(activeTab) && (!needsPole || pole !== null),
    sheetLabel: productTitle(t, activeTab),
    salePath: `${capitalize(activeTab)}Sale`,
    vaType: zohoSaleType,
    formulaSlots: { list: formulaList, notice },
  }
}

export default useAdditionalSalesV2Container
